var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"browser-message"},[_c('el-row',{staticClass:"description"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticClass:"row-center"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }